<template>
    <div>
        <div class="row">
            <div class="col-sm-8 explain_big">
                <div class="position-fixed">
                    <div class="back">
                        <a href="/menu"><img src="/static/tutorial/back.png" alt=""></a>
                    </div>
                    <div class="nav">
                        <nav class="navbar navbar-expand-lg text-center" style="background-color:#F0F0F0; border:#A0A0A0 solid 1px; padding:10px; font-size:0.8rem; color:black;">
                            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                                <ul class="navbar-nav">
                                    <li class="nav-item mr-1">
                                        <a class="hvr-grow"><img :src="datas[1].img" alt="" @click="indexChange(1)"><br>{{this.EventBus.getText("view_menu_paint")}}</a>
                                    </li>
                                    <li class="nav-item dropdown mr-3">
                                        <a class="hvr-grow dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[2].img" alt=""><br>{{this.EventBus.getText("view_menu_transparent")}}
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(2)"><img :src="datas[2].img" alt="" >{{this.EventBus.getText("view_menu_transparent")}}</a>
                                        <a class="dropdown-item" @click="indexChange(3)"><img :src="datas[3].img" alt="" >{{this.EventBus.getText("view_menu_opaque")}}</a>
                                        </div>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[4].img" alt="" @click="indexChange(4)"><br>{{this.EventBus.getText("view_menu_hide")}}</a>
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[5].img" alt="" @click="indexChange(5)"><br>{{this.EventBus.getText("view_menu_unhide")}}</a>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[6].img" alt="" @click="indexChange(6)"><br>{{this.EventBus.getText("view_menu_lock")}}</a>
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[7].img" alt="" @click="indexChange(7)"><br>{{this.EventBus.getText("view_menu_unlock")}}</a>
                                    </li>
                                    <li class="nav-item mr-2" style="border-left:0.5px solid; color:#C5C5C5">
                                    <li class="nav-item dropdown mr-2">
                                        <a class="hvr-grow dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src='"/static/tutorial/9. 화면/5. 배경 변경.png"' alt=""><br>{{this.EventBus.getText("view_menu_bload")}}
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(8)"><img :src='"/static/tutorial/9. 화면/5. 배경 변경.png"' alt="">{{this.EventBus.getText("view_menu_bload")}}</a>
                                        <a class="dropdown-item" @click="indexChange(8)"><img :src='"/static/tutorial/9. 화면/5. 배경 제거.png"' alt="">{{this.EventBus.getText("view_menu_bremove")}}</a>
                                        <a class="dropdown-item" @click="indexChange(9)"><img :src='"/static/tutorial/9. 화면/5. 배경 켜기.png"' alt="">{{this.EventBus.getText("view_menu_bon")}}</a>
                                        <a class="dropdown-item" @click="indexChange(9)"><img :src='"/static/tutorial/9. 화면/5. 배경 끄기.png"' alt="">{{this.EventBus.getText("view_menu_boff")}}</a>
                                        </div>
                                    </li>
                                    <li class="nav-item mr-2" style="border-left:0.5px solid; color:#C5C5C5">
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[10].img" alt="" @click="indexChange(10)"><br>{{this.EventBus.getText("view_menu_axis")}}</a>
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[11].img" alt="" @click="indexChange(11)"><br>{{this.EventBus.getText("view_menu_grid")}}</a>
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[12].img" alt="" @click="indexChange(12)"><br>{{this.EventBus.getText("view_menu_distance")}}</a>
                                    </li>
                                    <li class="nav-item mr-2" style="border-left:0.5px solid; color:#C5C5C5">
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[13].img" alt="" @click="indexChange(13)"><br>{{this.EventBus.getText("view_menu_properties")}}</a>
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[14].img" alt="" @click="indexChange(14)"><br>{{this.EventBus.getText("view_menu_list")}}</a>
                                    </li>


                                </ul>
                            </div>
                        </nav>
                    </div>
                    <img :src=datas[index].img alt="" style="height:100px">
                    <h1>{{datas[index].subject}}</h1>
                    <div class="explain_detail">
                        <p>{{datas[index].explain[0].ex1}}</p>
                        <p>{{datas[index].explain[0].ex2}}</p>
                        <div class="explain_order ml-2 ">
                            <p>{{datas[index].explain[0].ex3}}</p>
                            <p>{{datas[index].explain[0].ex4}}</p>
                            <p>{{datas[index].explain[0].ex5}}</p>
                            <p>{{datas[index].explain[0].ex6}}</p>
                        </div>
                    </div>
                    <div class="explain_button pt-5">
                        <button @click="prevButton()" :disabled='index == 0'>{{this.EventBus.getSystemText("previous")}}</button>
                        <button @click="nextButton()" :disabled='index == datas.length -1'>{{this.EventBus.getSystemText("next")}}</button>
                    </div>
                </div>

            </div>
            <div class="col-sm-4 explain_img">
                <div class="img_list " v-for="data in 3" v-bind:key="data.index">
                    <img :src="datas[index].imgex[data-1]" alt="" style="width:100%">
                </div>
            </div>
        </div>
        
        <js/>
    </div>
</template>


<script>
import View from '../../assets/language/look.json'
export default {
    beforeCreate() {
        this.EventBus.loadLanguage(View);
    },
    data() {
        return {
            subject: undefined,
            img: undefined,
            explain: [],
            index: 0,
            datas: [
                {
                    index: 0,
                    img: ' ',
                    subject:this.EventBus.getText("view_view"),
                    explain:
                        [
                            {  
                                ex1: this.EventBus.getText("view_view_ex"),
                                
                            },
                        ],
                    imgex: ['']
                },
                {
                    index: 1,
                    img: '/static/tutorial/4. 보기/1. 색 칠하기.png',
                    subject:this.EventBus.getText("view_paint"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("view_paint_ex1"), 
                            ex2: this.EventBus.getText("view_paint_ex2"),}
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/보기_0001_색칠하기-선택.png', 
                    '/static/tutorial/4. 보기/캡쳐/보기_0000_색칠하기-적용.png'] 
                },
                {
                    index: 2,
                    img: '/static/tutorial/4. 보기/2. 투명하게 보기.png',
                    subject:this.EventBus.getText("view_transparent"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_transparent_ex1"), 
                                ex2: this.EventBus.getText("view_transparent_ex2"),
                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/보기_0003_작업평면-준비.png', 
                    '/static/tutorial/4. 보기/캡쳐/보기_0002_투명불투명-적용.png']
                },
                {
                    index: 3,
                    img: '/static/tutorial/4. 보기/3. 불투명 보기.png',
                    subject:this.EventBus.getText("view_opaque"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_opaque_ex1"), 
                                ex2: this.EventBus.getText("view_opaque_ex2"),
                            },
                        ], 
                    imgex: ['/static/tutorial/4. 보기/캡쳐/보기_0003_작업평면-준비.png', 
                    '/static/tutorial/4. 보기/캡쳐/보기_0002_투명불투명-적용.png']
                },
                {
                    index: 4,
                    img: '/static/tutorial/4. 보기/4. 선택 숨기기.png',
                    subject:this.EventBus.getText("view_hide"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_hide_ex1"), 
                                ex2: this.EventBus.getText("view_hide_ex2"),
                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/숨기기_0001_숨기기-준비.png', 
                    '/static/tutorial/4. 보기/캡쳐/숨기기_0000_숨기기-적용.png']
                },
                {
                    index: 5,
                    img: '/static/tutorial/4. 보기/5. 모두 보이기.png',
                    subject:this.EventBus.getText("view_unhide"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_unhide_ex1"), 
                                ex2: this.EventBus.getText("view_unhide_ex2"),
                            }
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/숨기기_0001_숨기기-준비.png', 
                    '/static/tutorial/4. 보기/캡쳐/숨기기_0000_숨기기-적용.png'] 
                },
                {
                    index: 6,
                    img: '/static/tutorial/4. 보기/6. 선택 잠금.png',
                    subject:this.EventBus.getText("view_lock"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_lock_ex1"), 
                                ex2: this.EventBus.getText("view_lock_ex2"),
                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/잠금_0001_잠금-준비.png', 
                    '/static/tutorial/4. 보기/캡쳐/잠금_0000_잠금-적용.png']
                },
                {
                    index: 7,
                    img: '/static/tutorial/4. 보기/7. 모두 잠금해제.png',
                    subject:this.EventBus.getText("view_unlock"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_unlock_ex1"), 
                                ex2: this.EventBus.getText("view_unlock_ex2"),
                            }
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/잠금_0001_잠금-준비.png', 
                    '/static/tutorial/4. 보기/캡쳐/잠금_0000_잠금-적용.png']
                     
                },
                {
                    index: 8,
                    img: '/static/tutorial/4. 보기/9. 배경 변경제거.png',
                    subject:this.EventBus.getText("view_menu_load"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_menu_load_ex1"), 
                                ex2: this.EventBus.getText("view_menu_load_ex2"),

                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/화면_0014_배경-선택.png', 
                    '/static/tutorial/4. 보기/캡쳐/화면_0013_배경-선택2.png', 
                    '/static/tutorial/4. 보기/캡쳐/화면_0012_배경-적용.png']
                },
                {
                    index: 9,
                    img: '/static/tutorial/4. 보기/11. 배경 켜기끄기.png',
                    subject:this.EventBus.getText("view_bon"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_bon_ex1"), 
                                ex2: this.EventBus.getText("view_bon_ex2"),
 
                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/화면_0012_배경-적용.png',
                    '/static/tutorial/4. 보기/캡쳐/화면_0011_배경제거_끄기.png'] 
                },
                {
                    index: 10,
                    img: '/static/tutorial/4. 보기/12. 중심축.png',
                    subject:this.EventBus.getText("view_axis"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_axis_ex"),
                            }

                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/화면_0007_중심축-OFF.png', 
                    '/static/tutorial/4. 보기/캡쳐/화면_0006_중심축-ON.png'] 
                },
                {
                    index: 11,
                    img: '/static/tutorial/4. 보기/13. 작업 평면.png',
                    subject:this.EventBus.getText("view_grid"),
                    explain:
                        [
                            {
                               ex1: this.EventBus.getText("view_grid_ex"), 
                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/화면_0009_작업평면-ON.png', 
                    '/static/tutorial/4. 보기/캡쳐/화면_0008_작업평면-OFF.png'] 
                },
                {
                    index: 12,
                    img: '/static/tutorial/4. 보기/14. 이동 거리.png',
                    subject:this.EventBus.getText("view_distance"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_distance_ex"), 
                            }

                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/화면_0010_이동거리-준비.png', 
                    '/static/tutorial/4. 보기/캡쳐/화면_0009_이동거리-OFF.png', 
                    '/static/tutorial/4. 보기/캡쳐/화면_0008_이동거리-ON.png'] 
                },   
                {
                    index: 13,
                    img: '/static/tutorial/4. 보기/15. 속성.png',
                    subject:this.EventBus.getText("view_properties"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_properties_ex"), 
                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/화면_0016_속성.png']
                },
                {
                    index: 14,
                    img: '/static/tutorial/4. 보기/16. 도형 목록.png',
                    subject:this.EventBus.getText("view_list"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("view_list_ex"), 
                            },
                        ],
                    imgex: ['/static/tutorial/4. 보기/캡쳐/화면_0015_도형목록.png'] 
                },

            ]
        } 
    },
    created() {
        this.push(this.index);
    },
    methods: {
        nextButton() {
            this.index = this.index + 1;
            window.scrollTo(0,0);
        },
        prevButton() {
            this.index = this.index - 1;
            window.scrollTo(0,0);
        },
        push(index) {
            this.subject =  this.datas[index].subject
            this.img = this.datas[index].img
            this.explain = [this.datas[index].explain[index].ex1, this.datas[index].explain[index].ex2, this.datas[index].explain[index].ex3, this.datas[index].explain[index].ex4, this.datas[index].explain[index].ex5, this.datas[index].explain[index].ex6]
            this.imgex = this.datas[index].imgex
        
        },
        indexChange(index){
            this.index = index;
            window.scrollTo(0,0);
        },
        myFunction() {
            document.getElementById("myDropdown").classList.toggle("show");
        },
        myFunction2() {
            document.getElementById("myDropdown2").classList.toggle("show");
        } 
    }
    
}
</script>

<style scoped>
    
    p {
        color: black;
    }
    .explain_big {
        padding: 0 12vw;
        margin-top: 8vw;
        float: left;
    }

    h1 {
        font-size: 25px;
        color: black;
        font-weight: 700;

    }

    .explain_detail p{
        padding: 0px;
        margin: 0px;

    }

    .explain_order p{
        margin: 0px;
        padding: 0px;
    }

    button{
        border-radius: 30px;
        padding: 3px 30px;
        margin: 10px;
        border-color: lightgray;
        border-style: solid;
        background-color: white;
        font-size: 0.8rem;
        outline: 0;
    }
    .explain_img {
        right: 0;
        width: 100%;
        padding-top: 150px;
        /* background-color: white; */
    }
    .img_list {
        float: right;
    }
    .back img{
        margin-left: -100px;
        width: 35px;
        height: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
    
    .navBar img{
        display: flex;
        width: 100%;
        height: auto;
    }
    .nav-item{
        display: block;
        cursor: pointer;
    }

    .nav-item img{
        width: 35px;
        height: 35px;
        margin-bottom: 0.3vw;
    }

    .dropdown-menu img{
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
    .dropdown-menu a{
        font-size: 15px;
    }
    .nav{
        margin-bottom: 6vw;
    }
    a { color: inherit; } 
    .hvr-grow {
        margin: 8px;
        display: inline-block;
        vertical-align: middle;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: transform;
        transition-property: transform;
        }
        .hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
        -webkit-transform: scale(1.1);
        transform: scale(1.2);
        }
</style>


// WEBPACK FOOTER //
// src/pages/tutorial_menu/look_menu.vue